/**
 * Simple Icon System
 * Sets --icon-url CSS custom property based on data-icon attributes
 */

function initIcons(root = document) {
  const iconElements = root === document
    ? document.querySelectorAll('[data-icon]:not([data-icon-initialized])')
    : collectIconElements(root);

  const basePath = window.alloyTheme?.iconBasePath || '/icons/';

  iconElements.forEach((element) => {
    const iconName = element.dataset.icon;
    if (iconName) {
      element.style.setProperty('--icon-url', `url("${basePath}${iconName}.svg")`);
      element.dataset.iconInitialized = 'true';
    }
  });
}

function collectIconElements(root) {
  const elements = [];

  if (root.nodeType === Node.ELEMENT_NODE && root.matches('[data-icon]:not([data-icon-initialized])')) {
    elements.push(root);
  }

  if (root.querySelectorAll) {
    root.querySelectorAll('[data-icon]:not([data-icon-initialized])').forEach((el) => {
      elements.push(el);
    });
  }

  return elements;
}

function observeDynamicIcons() {
  const observer = new MutationObserver((mutations) => {
    const hasNewIcons = mutations.some(({ addedNodes }) =>
      [...addedNodes].some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('[data-icon]:not([data-icon-initialized])') ||
            node.querySelector?.('[data-icon]:not([data-icon-initialized])')),
      ),
    );

    if (hasNewIcons) {
      initIcons();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  initIcons();
  observeDynamicIcons();
});

// Export for manual use if needed
window.initIcons = initIcons; 